module.exports = __webpack_public_path__ + "static/media/good-thumb.a2541a0b.jpg";